module.exports = __webpack_public_path__ + "static/media/stopwatch.fb9e4fa3.svg";